/**
 * Manipulate and use a single URLSearchParams value.
 * Includes helpers to work with array parameters. e.g., foo=val1&foo=val2.
 */
export class SingleQuery {
  private query: URLSearchParams;
  private queryName: string;

  constructor(query: URLSearchParams, queryName: string) {
    this.query = query;
    this.queryName = queryName;
  }

  getValue = (): string | null => this.query.get(this.queryName);
  getValues = (): string[] => this.query.getAll(this.queryName);

  /**
   * Query functions
   */
  set = (value: string) => this.query.set(this.queryName, value);
  append = (value: string) => this.query.append(this.queryName, value);
  deleteQuery = () => this.query.delete(this.queryName);

  /**
   * Value functions
   */
  without = (removeValue: string) =>
    this.getValues().filter((value) => value !== removeValue);
  includes = (value: string): boolean => this.getValues().includes(value);
}
